/**
 * Retrieves the appropriate interest rate based on the provided rates and vehicle condition.
 *
 * @param {Object} rates - An object containing interest rate values.
 * @param {number} [rates.new] - The interest rate for new vehicles.
 * @param {number} [rates.used] - The interest rate for used vehicles.
 * @param {number} [rates.custom] - A custom interest rate, which will be returned as an absolute value if negative.
 * @param {string} [vehicleCondition='used'] - The condition of the vehicle ('new', 'used', or 'certified').
 * @returns {number} The applicable interest rate. Defaults to 4.5 if invalid data is provided.
 */
const getInterestRate = function () {
  let rates = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  let vehicleCondition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'used';
  if (!!rates && Object.keys(rates).length > 0) {
    const {
      new: newRate,
      used,
      custom
    } = rates;
    if (typeof custom === 'number') {
      // return absolute value if a negative rate is provided
      return Math.abs(custom);
    }
    if ((vehicleCondition.toLowerCase() === 'used' || vehicleCondition.toLowerCase() === 'certified') && used >= 0) {
      return used;
    }
    if (newRate >= 0) {
      // Support for zero special APR
      return newRate;
    }
  }
  return 4.5; // Return only if invalid data is provided
};
export { getInterestRate as default };
